module.exports = __webpack_public_path__ + "static/img/inverted-ramp-8m-x-1m_256.1717ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inverted-ramp-8m-x-1m_256.png
// module id = dL9N
// module chunks = 0